import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-pricing',
    templateUrl: './pricing.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
    @Input() class: string = "";
    constructor(
        public router: Router,
        private translate: TranslateService
    ) { }

    ngOnInit(): void { }

}